export const HOME_PATH = 'home';
export const LOG_ACTION_PATH = 'log-action';
export const ACCOUNTS_PATH = 'accounts';
export const ACCOUNT_INFORMATION_PATH = 'account-information';
export const GLOBAL_SEARCH_PATH = 'global-search';
export const CONTACT_INFORMATION_PATH = 'contact-information';
